import { LocationDetailsProps } from "@/types";
import { cn } from "@/lib/utils";
import { FaLocationDot, FaPhone, FaEnvelope, FaWhatsapp } from "react-icons/fa6";

export default function LocationDetails({
    address,
    phone,
    email,
    whatsapp,
    className,
}: LocationDetailsProps) {
    return (
        <div className={cn("flex flex-col gap-4 text-white font-poppins", className)}>

            {address && (
                <div className="flex items-start gap-4">
                    <FaLocationDot className="w-5 h-5 text-white shrink-0 mt-1" />
                    <p className="text-sm sm:text-base text-brand-cream/90 leading-relaxed max-w-md">
                        {address}
                    </p>
                </div>
            )}

            {phone && (
                <div className="flex items-center gap-4">
                    <FaPhone className="w-5 h-5 text-white shrink-0" />
                    <a
                        href={`tel:${phone.replace(/\s+/g, "")}`}
                        className="text-sm sm:text-base text-brand-cream/90 hover:text-brand-green transition-colors"
                    >
                        {phone}
                    </a>
                </div>
            )}
            {whatsapp && (
                <div className="flex items-center gap-4">
                    <FaWhatsapp className="w-5 h-5 text-white shrink-0" />
                    <a
                        href={`https://wa.me/${whatsapp.replace(/\s+/g, "")}`}
                        className="text-sm sm:text-base text-brand-cream/90 hover:text-brand-green transition-colors"
                    >
                        {whatsapp}
                    </a>
                </div>
            )}

            {email && (
                <div className="flex items-center gap-4">
                    <FaEnvelope className="w-5 h-5 text-white shrink-0" />
                    <a
                        href={`mailto:${email}`}
                        className="text-sm sm:text-base text-brand-cream/90 hover:text-brand-green transition-colors break-all"
                    >
                        {email}
                    </a>
                </div>
            )}
        </div>
    );
}
